// App.tsx
// BOT-EDIT: 2025-01-27T10:45:00Z Add SubscriptionProvider and invoice pages to App.tsx
import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardPage from './pages/DashboardPage';
import CardCreatePage from './pages/CardCreatePage';
import FirebaseTestPage from './pages/FirebaseTestPage';
import UserProfilePage from './pages/UserProfilePage';
import QRDesignPage from './pages/QRDesignPage';
import CardEditorPage from './pages/CardEditorPage';
import InvoiceCreationPage from './pages/InvoiceCreationPage';
import InvoiceEditPage from './pages/InvoiceEditPage';
import InvoiceListPage from './pages/InvoiceListPage';
import InvoiceSuccessPage from './pages/InvoiceSuccessPage';
import BusinessProfilePage from './pages/BusinessProfilePage';
import StatsDetailPage from './pages/StatsDetailPage';
import DomainSettingsPage from './pages/DomainSettingsPage';
import CustomDomainSettingsPage from './pages/CustomDomainSettingsPage';
import StripePaywallPage from './pages/StripePaywallPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';

function App() {
  console.log('[App.tsx] App component rendering...');
  console.log('[App.tsx] Using LandingPage as main page');
  
  const { i18n } = useTranslation();
  
  useEffect(() => {
    console.log('🌐 App - Current language:', i18n.language);
    console.log('🌐 App - Available languages:', i18n.languages);
    console.log('🌐 App - Is initialized:', i18n.isInitialized);
    
    // 언어 변경 시 리렌더링 강제
    const handleLanguageChange = () => {
      console.log('🌐 App - Language changed to:', i18n.language);
      // 상태 업데이트로 리렌더링 유도
      window.dispatchEvent(new Event('languageChanged'));
    };
    
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return (
    <AuthProvider>
      <SubscriptionProvider>
        <div className="App">
          <Routes>
            {/* 랜딩 페이지 - 헤더/푸터 없음 */}
            <Route path="/" element={<LandingPage />} />
            
            {/* 일반 페이지들 - 헤더/푸터 있음 */}
            <Route path="/home" element={
              <Layout>
                <HomePage />
              </Layout>
            } />
            <Route path="/login" element={
              <Layout showFooter={false}>
                <LoginPage />
              </Layout>
            } />
            <Route path="/register" element={
              <Layout showFooter={false}>
                <RegisterPage />
              </Layout>
            } />
            <Route path="/forgot-password" element={
              <Layout showFooter={false}>
                <ForgotPasswordPage />
              </Layout>
            } />
            <Route path="/dashboard" element={
              <Layout>
                <DashboardPage />
              </Layout>
            } />
            <Route path="/card/create" element={
              <Layout>
                <CardCreatePage />
              </Layout>
            } />
            <Route path="/firebase-test" element={
              <Layout>
                <FirebaseTestPage />
              </Layout>
            } />
            
            {/* Invoice management routes */}
            <Route path="/invoice/create" element={
              <Layout>
                <InvoiceCreationPage />
              </Layout>
            } />
            <Route path="/invoice/:cardId/:invoiceId/edit" element={
              <Layout>
                <InvoiceEditPage />
              </Layout>
            } />
            <Route path="/invoices" element={
              <Layout>
                <InvoiceListPage />
              </Layout>
            } />
            <Route path="/cards/:cardId/invoices" element={
              <Layout>
                <InvoiceListPage />
              </Layout>
            } />
            <Route path="/invoice-success" element={
              <Layout>
                <InvoiceSuccessPage />
              </Layout>
            } />
            <Route path="/business-profile" element={
              <Layout>
                <BusinessProfilePage />
              </Layout>
            } />
            
            {/* 통계 상세 페이지 */}
            <Route path="/stats/:cardId" element={
              <Layout>
                <StatsDetailPage />
              </Layout>
            } />
            <Route path="/stats/:cardId/:ownerId" element={
              <Layout>
                <StatsDetailPage />
              </Layout>
            } />
            
            {/* Card management routes - 동적 라우트보다 먼저 배치 */}
            <Route path="/cards/:cardId/qr-design" element={
              <Layout>
                <QRDesignPage />
              </Layout>
            } />
            <Route path="/cards/:cardId/edit" element={
              <Layout>
                <CardEditorPage />
              </Layout>
            } />
            <Route path="/domain-settings" element={
              <Layout>
                <DomainSettingsPage />
              </Layout>
            } />
            <Route path="/custom-domain-settings" element={
              <Layout>
                <CustomDomainSettingsPage />
              </Layout>
            } />
            
            {/* Payment Success Page - username 동적 라우트보다 먼저 배치 */}
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            
            {/* Stripe Paywall Page - username 동적 라우트보다 먼저 배치 */}
            <Route path="/paywall" element={<StripePaywallPage />} />
            
            {/* Invoice edit route - username 동적 라우트보다 먼저 배치 */}
            <Route path="/invoices/:invoiceId/edit" element={
              <Layout>
                <InvoiceEditPage />
              </Layout>
            } />
            
            {/* username 동적 라우트: /t2design, /alice, /bob ... - 헤더/푸터 없음 */}
            <Route path="/:username" element={<UserProfilePage />} />
            
            {/* 마지막에 catch-all 유지 (진짜 404만 루트로 보냄) */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;